import { CLIENTS_EDIT } from 'src/store/ActionTypes';

export const unset = (property, value) => ({
  type: CLIENTS_EDIT.UNSET,
  payload: { property, value },
});

export const fetchClient = (id) => ({
  type: CLIENTS_EDIT.FETCH_CLIENT,
  payload: id,
});

export const enableRealTimeApi = (payload) => ({
  type: CLIENTS_EDIT.ENABLE_REAL_TIME_API,
  payload,
});

export const disableRealTimeApi = (payload) => ({
  type: CLIENTS_EDIT.DISABLE_REAL_TIME_API,
  payload,
});

export const editClient = (clientId, client) => ({
  type: CLIENTS_EDIT.EDIT_CLIENT,
  payload: {
    clientId,
    client,
  },
});

export const fetchOnboardingConfigTypes = (query) => ({
  type: CLIENTS_EDIT.FETCH_ONB_CONFIG_TYPES,
  payload: query,
});

export const fetchClientOnboardingConfig = (type, scopeClientType, tenant) => ({
  type: CLIENTS_EDIT.FETCH_CLIENT_ONB_CONFIG,
  payload: {
    type,
    scopeClientType,
    tenant,
  },
});

export const fetchOnboardingConfigsL1 = (query) => ({
  type: CLIENTS_EDIT.FETCH_ONB_CONFIGS_L1,
  payload: query,
});

export const fetchOnboardingConfigsL2 = (query) => ({
  type: CLIENTS_EDIT.FETCH_ONB_CONFIGS_L2,
  payload: query,
});

export const fetchOnboardingConfigsL3 = (query) => ({
  type: CLIENTS_EDIT.FETCH_ONB_CONFIGS_L3,
  payload: query,
});

export const editOnboardingConfig = (id, onboardingConfig) => ({
  type: CLIENTS_EDIT.EDIT_ONB_CONFIG,
  payload: {
    id,
    onboardingConfig,
  },
});

export const addOnboardingConfig = (onboardingConfig) => ({
  type: CLIENTS_EDIT.ADD_ONB_CONFIG,
  payload: onboardingConfig,
});
